export default "__VITE_ASSET__gCmTXVKG__"